import currencyPipe from 'src/utils/currencyPipe';
import WarningFilled from 'src/components/Icons/WarningFilled';

interface Props {
	pnl: number;
	feesAndFunding: number | undefined;
	pnlColorClassName: string;
	feesAndFundingColorClassName: string;
	isMockedSnapshot: boolean | undefined;
}

export default function PortfolioTradeCalendarTooltipContent({
	pnl,
	feesAndFunding,
	pnlColorClassName,
	feesAndFundingColorClassName,
	isMockedSnapshot,
}: Props) {
	if (isMockedSnapshot) {
		return (
			<>
				<div className="flex items-start gap-x-xs">
					<WarningFilled className="text-star-yellow" size={16} />
					<span>Snapshot data is missing</span>
				</div>
				<span>Data in History is not affected</span>
			</>
		);
	}

	return (
		<>
			<div className="flex items-center justify-between gap-x-lg">
				<span>P&L</span>
				<span className={pnlColorClassName}>{currencyPipe(pnl, '$', 2)}</span>
			</div>
			{feesAndFunding !== undefined && (
				<div className="flex items-center justify-between gap-x-lg">
					<span>Fees and Funding</span>
					<span className={feesAndFundingColorClassName}>
						{currencyPipe(feesAndFunding, '$', 2)}
					</span>
				</div>
			)}
		</>
	);
}
